
export const state = {
  mockedClient: null
};
